export default __webpack_public_path__ + "static/media/remove.55b069bd.svg";